import React, { useRef } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import useIsMobile from '../../hooks/useIsMobile';
import { MOBILE_TOUCH_MIN_PX, mobileDialogPaperSx } from '../../theme/mobileLayout';
import { actionConfirmationMessage } from './chatArtifactActions';

export default function ChatActionConfirmDialog({ action, onCancel, onConfirm }) {
  const isMobile = useIsMobile();
  // Keep the quote readable during MUI's closing transition.
  const lastAction = useRef(action);
  if (action) lastAction.current = action;
  const displayedAction = action || lastAction.current;
  const cancelRef = useRef(null);
  const confirmRef = useRef(null);
  const maximum = displayedAction?.quote?.total_is_maximum === true && Number.isFinite(displayedAction?.quote?.total_credits)
    ? `Up to ${displayedAction.quote.total_credits} credits` : null;
  const lines = displayedAction ? actionConfirmationMessage(displayedAction).split('\n') : [];
  if (maximum && !lines.includes(maximum)) lines.push(maximum);
  const leadFinder = displayedAction?.key === 'lead_finder_contacts';

  return (
    <Dialog
      open={Boolean(action)}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
      PaperProps={{ 'aria-modal': true, sx: mobileDialogPaperSx(isMobile) }}
      aria-labelledby="chat-action-confirm-title"
      aria-describedby="chat-action-confirm-description"
      TransitionProps={{ onEntered: () => {
        // A closing Menu may restore focus outside the dialog. Repair that race
        // without undoing a user's Tab to Confirm during the enter animation.
        if (document.activeElement !== confirmRef.current) cancelRef.current?.focus();
      } }}
    >
      <DialogTitle id="chat-action-confirm-title">Confirm chat action</DialogTitle>
      <DialogContent id="chat-action-confirm-description" sx={{ overflowWrap: 'anywhere' }}>
        <Stack spacing={2}>
          {lines.map((line, index) => /^up to /i.test(line)
            ? <Alert severity="info" key={index}>{line}</Alert>
            : <Typography key={index}>{line}</Typography>)}
          {leadFinder && <Typography>Companies looked up in our contact data provider are charged even if no contact is found. Other companies are charged only when a verified contact is found.</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1, flexWrap: 'wrap' }}>
        <Button autoFocus ref={cancelRef} onClick={onCancel} sx={{ minHeight: MOBILE_TOUCH_MIN_PX }}>Cancel</Button>
        <Button ref={confirmRef} variant="contained" onClick={onConfirm} sx={{ minHeight: MOBILE_TOUCH_MIN_PX }}>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}
